'use client';

import { useState } from 'react';
import Image from 'next/image';
import type { Item } from '@/lib/types';

function itemImagePath(item: Pick<Item, 'id' | 'itemType'>): string {
  return item.itemType === 'card'
    ? `/images/cards/${item.id}.png`
    : `/images/relics/${item.id}.png`;
}

interface Props {
  item: Pick<Item, 'id' | 'itemType' | 'name'>;
  className?: string;
  width: number;
  height: number;
}

export default function WikiImage({ item, className, width, height }: Props) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;

  return (
    <Image
      src={itemImagePath(item)}
      alt={item.name}
      width={width}
      height={height}
      onError={() => setFailed(true)}
      className={className}
    />
  );
}
